import { render, staticRenderFns } from "./RegistrationRecap.vue?vue&type=template&id=36f18a13"
import script from "./RegistrationRecap.vue?vue&type=script&lang=js"
export * from "./RegistrationRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports